import { Engine } from "../Engine";

export abstract class Asset {
    abstract resolveAsset(engine: Engine): Promise<void>;
}